export enum SSE_TYPE {
  NOTI = 'noti-type',
  STATUS = 'status-type',
}
